export const deliveryProblemsData = {
  buttons: [
    {
      label: 'My delivery is late and I want to complain',
      id: 'lateDelivery',
    },
    {
      label: 'My goods were delivered damaged',
      id: 'damagedGoods',
    },
    {
      label: 'My delivery was left somewhere and is now missing',
      id: 'missingDelivery',
    },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/c5658058b72b-tooliconboxwarning.jpg',
  },
  title: "What's the problem with your delivery?",
}
